<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2c">Contents</h2>
<p class="toc"><a href="#/xhtml/chapter01">1    A Night Vigil</a></p>
<p class="toc"><a href="#/xhtml/chapter02">2    Another Day</a></p>
<p class="toc"><a href="#/xhtml/chapter03">3    The Merchant City Health Centre</a></p>
<p class="toc"><a href="#/xhtml/chapter04">4    The Centre of the Universe</a></p>
<p class="toc"><span href="#/xhtml/chapter05" title="Link target outside of Sample">5    The Most Beautiful Girl in the World</span></p>
<p class="toc"><span href="#/xhtml/chapter06" title="Link target outside of Sample">6    Special Delivery</span></p>
<p class="toc"><span href="#/xhtml/chapter07" title="Link target outside of Sample">7    Life Goes On</span></p>
<p class="toc"><span href="#/xhtml/chapter08" title="Link target outside of Sample">8    A Work of Art</span></p>
<p class="toc"><span href="#/xhtml/chapter09" title="Link target outside of Sample">9    An Interesting Day</span></p>
<p class="toc"><span href="#/xhtml/chapter10" title="Link target outside of Sample">10  A Stranger in Town</span></p>
<p class="toc"><span href="#/xhtml/chapter11" title="Link target outside of Sample">11  Justine</span></p>
<p class="toc"><span href="#/xhtml/chapter12" title="Link target outside of Sample">12  Out to Lunch</span></p>
<p class="toc"><span href="#/xhtml/chapter13" title="Link target outside of Sample">13  How to Clean Up in the Sex Business</span></p>
<p class="toc"><span href="#/xhtml/chapter14" title="Link target outside of Sample">14  The Way Ahead</span></p>
<p class="toc"><span href="#/xhtml/chapter15" title="Link target outside of Sample">15  The Subplot Thickens . . .</span></p>
<p class="toc"><span href="#/xhtml/chapter16" title="Link target outside of Sample">16  . . . And Thickens</span></p>
<p class="toc"><span href="#/xhtml/chapter17" title="Link target outside of Sample">17  Citizen Kane</span></p>
<p class="toc"><span href="#/xhtml/chapter18" title="Link target outside of Sample">18  Consequences</span></p>
<p class="toc"><span href="#/xhtml/chapter19" title="Link target outside of Sample">19  A Quiet Night on the Western Front</span></p>
<p class="toc"><span href="#/xhtml/chapter20" title="Link target outside of Sample">20  Best of Three</span></p>
<p class="toc"><span href="#/xhtml/chapter21" title="Link target outside of Sample">21  The Talk of the Steam Room</span></p>
<p class="toc"><span href="#/xhtml/chapter22" title="Link target outside of Sample">22  Forebodings</span></p>
<p class="toc"><span href="#/xhtml/chapter23" title="Link target outside of Sample">23  Next on the List?</span></p>
<p class="toc"><span href="#/xhtml/chapter24" title="Link target outside of Sample">24  Hitting the Fan</span></p>
<p class="toc"><span href="#/xhtml/chapter25" title="Link target outside of Sample">25  Some Expert Views</span></p>
<p class="toc"><span href="#/xhtml/chapter26" title="Link target outside of Sample">26  Diversification</span></p>
<p class="toc"><span href="#/xhtml/chapter27" title="Link target outside of Sample">27  A Suspect?</span></p>
<p class="toc"><span href="#/xhtml/chapter28" title="Link target outside of Sample">28  Becoming Restless</span></p>
<p class="toc"><span href="#/xhtml/chapter29" title="Link target outside of Sample">29  A Return Visit</span></p>
<p class="toc"><span href="#/xhtml/chapter30" title="Link target outside of Sample">30  Another Return Visit</span></p>
<p class="toc"><span href="#/xhtml/chapter31" title="Link target outside of Sample">31  Room Service</span></p>
<p class="toc"><span href="#/xhtml/chapter32" title="Link target outside of Sample">32  Room 123</span></p>
<p class="toc"><span href="#/xhtml/chapter33" title="Link target outside of Sample">33  Helping with Inquiries</span></p>
<p class="toc"><span href="#/xhtml/chapter34" title="Link target outside of Sample">34  Claudia’s Vault</span></p>
<p class="toc"><span href="#/xhtml/chapter35" title="Link target outside of Sample">35  Sex and Violins</span></p>
<p class="toc"><span href="#/xhtml/chapter36" title="Link target outside of Sample">36  Four Jacks</span></p>
<p class="toc"><span href="#/xhtml/chapter37" title="Link target outside of Sample">37  Insufficient Evidence</span></p>
<p class="toc"><span href="#/xhtml/chapter38" title="Link target outside of Sample">38  Sufficient Evidence</span></p>
<p class="toc"><span href="#/xhtml/chapter39" title="Link target outside of Sample">39  The Moral of the Story?</span></p>
<p class="toc"><span href="#/xhtml/chapter40" title="Link target outside of Sample">40  Visiting Time</span></p>
<p class="toc1"><span href="#/xhtml/bm01" title="Link target outside of Sample"><em>Acknowledgements</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?57c4538a